import React from 'react';
import IconButton from '../IconButton';
import {
  IconLikeHeartActive16,
  IconLikeHeartInactive16,
  IconLikeHeartActive24,
  IconLikeHeartInactive24,
} from '../icons';

export interface SaveBookmarkProps {
  isSaved: boolean;
  disabled?: boolean;
  onClick: () => void;
  size: 'small' | 'large';
}

const SaveBookmark = ({
  isSaved,
  disabled,
  onClick,
  size,
}: SaveBookmarkProps) => {
  const label = isSaved ? 'Remove saved item' : 'Save item';
  const isSmallIcon = size === 'small';

  const ActiveIcon = isSmallIcon
    ? IconLikeHeartActive16
    : IconLikeHeartActive24;

  const InactiveIcon = isSmallIcon
    ? IconLikeHeartInactive16
    : IconLikeHeartInactive24;

  return (
    <IconButton
      aria-label={label}
      onClick={onClick}
      disabled={disabled}
      variant="overlay"
    >
      {isSaved ? <ActiveIcon color="grapefruit-60" /> : <InactiveIcon />}
    </IconButton>
  );
};

export default SaveBookmark;
